export function Footer() {
  return (
    <footer className="footer flex flex-wrap justify-between border-t">
      <p>&copy; 2024 Euphoria Development. All rights reserved.</p>
      <div className="footer-links flex font-semibold">
        <a
          href="https://euphoriadevelopment.uk/"
          target="_blank"
          rel="noreferrer"
        >
          Euphoria Development
        </a>
        <a
          href="https://discord.gg/Cus2zP4pPH"
          target="_blank"
          rel="noreferrer"
        >
          Discord
        </a>
        <a
          href="https://github.com/EuphoriaTheme"
          target="_blank"
          rel="noreferrer"
        >
          GitHub
        </a>
      </div>
    </footer>
  );
}
